import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { GameInterface } from "src/app/interfaces/lobby.interface";
import { UserSessionService } from "../user-session/user-session.service";
import { WebservicesService } from "../webservices/webservices.service";
import { StructureHelperService } from "../structure/structure-helper.service";
import { API_LIB } from "src/library/api.lib";

@Injectable({ providedIn: 'root' })
export class LastPlayedService {

    private lastPlayedSubject = new BehaviorSubject<GameInterface[]>([]);
    public lastPlayed$ = this.lastPlayedSubject.asObservable();

    constructor(
        private webService: WebservicesService,
        private structureHelper: StructureHelperService,
        private userService: UserSessionService
    ) { }


    loadlLastPlayed(): void {

        this.structureHelper.getMainLobbyName().subscribe(name => {

            this.webService
                .get(API_LIB.LOBBY_LAST_PLAYED(name), {
                    customer_id: this.userService.customer.customerId,
                    session_token: this.userService.sessionToken,
                })
                .subscribe((res) => {
                    this.lastPlayedSubject.next(res.payload);
                });
        });
    }

    refreshLastPlayed() {
        this.loadlLastPlayed();
    }

}
